<template>
    <div>
        <div v-if="ppContent" class="text-center pb-6">
            <div class="text-center font-bold mb-1">Payment Protection</div>
            <img
                alt="Payment Protection Certificate"
                class="mx-auto mb-1"
                src="https://images.simplyowners.net/assets/certs.jpg"
            />
            If you book this property remember to ask the owner to send you a
            SimplyOwners Free Payment Protection Certificate.<br />
            <div class="text-center mb-1">
                <a
                    class="inline-block border border-green-600 bg-green-600 text-white
            rounded-md px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-green-700 focus:outline-none focus:shadow-outline"
                    href="/payment-protection"
                    target="_blank"
                    >Payment Protection Information</a
                >
            </div>
        </div>
        <div
            v-if="instantErrors"
            class="bg-red-600 text-white py-2 px-4 pr-0 rounded font-bold mb-4 shadow-lg"
        >
            <div v-for="(v, k) in instantErrors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                    {{ error }}
                </p>
            </div>
        </div>
        <div
            v-if="!hasEmail && !hasPhone && !hasWebsite"
            class="text-center font-bold"
        >
            You are unable to contact this owner at this time.
        </div>
        <button
            v-if="hasEmail"
            class="my-2 mx-auto text-center w-9/12 block px-4 py-2 cursor-pointer font-bold text-white text-lg bg-indigo-600 border-solid border rounded border-gray-300 hover:bg-indigo-700 hover:shadow-lg transform focus:scale-95 focus:outline-none focus:bg-indigo-500"
            @click="showContact('email')"
            :disabled="illustration"
        >
            Send message to owner
        </button>
        <button
            v-if="hasPhone"
            :id="instantAccess ? 'button-click-phone' : null"
            class="my-2 mx-auto text-center w-9/12 block px-4 py-2 cursor-pointer font-bold text-white text-lg bg-indigo-600 border-solid border rounded border-gray-300 hover:bg-indigo-700 hover:shadow-lg transform focus:scale-95 focus:outline-none focus:bg-indigo-500"
            @click="showContact('phone')"
            :disabled="illustration"
        >
            Get owner's phone number
        </button>
        <div v-if="phoneContent" class="text-center pb-6">
            <span class="text-lg font-bold">Contact {{ property.owner }}:</span
            ><br />
            <div
                v-for="phone in ownerPhone"
                class="text-3xl font-nova-regular text-so-green"
            >
                <div v-if="phone.phone_number" class="grid gap-2 mt-6">
                    <a
                        :href="'tel:' + phone.phone_number"
                        class="hover:underline hover:text-green-700"
                        >Call <i class="icon-phone" />:
                        {{ phone.phone_number }}</a
                    >
                    <a
                        v-if="phone.whatsapp"
                        :href="
                            'https://api.whatsapp.com/send?phone=' +
                                phone.phone_number
                        "
                        target="_blank"
                        class="hover:underline hover:text-green-700"
                        >WhatsApp <i class="icon-whatsapp" />:
                        {{ phone.phone_number }}</a
                    >
                </div>
            </div>
        </div>
        <button
            v-if="hasWebsite"
            :id="instantAccess ? 'button-click-website' : null"
            class="my-2 mx-auto text-center w-9/12 block px-4 py-2 cursor-pointer font-bold text-white text-lg bg-indigo-600 border-solid border rounded border-gray-300 hover:bg-indigo-700 hover:shadow-lg transform focus:scale-95 focus:outline-none focus:bg-indigo-500"
            @click="showContact('website')"
            :disabled="illustration"
        >
            View owner's website
        </button>
        <div v-if="websiteContent" class="text-center pb-6">
            <span class="text-lg font-bold">Visit the property website:</span
            ><br />
            <a
                :href="ownerWebsite"
                class="text-3xl font-nova-regular text-so-green px-1 hover:underline hover:text-green-700"
                target="_blank"
                >Click to open website</a
            >
        </div>
        <PropertyContactComponent
            v-if="contactOwnerShow"
            :property="property"
            :has-phone="hasPhone"
            :has-email="hasEmail"
            :has-website="hasWebsite"
            :random="random"
            :ip="ip"
            :user-level="userLevel"
            :availability="availability"
            :property-rule-sets="propertyRuleSets"
            :pets-allowed="petsAllowed"
            :nhs-discount="nhsDiscount"
            :show-nhs-discount="showNhsDiscount"
            @phone-response="responsePhone"
            @website-response="responseWebsite"
        >
        </PropertyContactComponent>
    </div>
</template>
<script>
import { store, mutations } from "./store";
export default {
    name: "PropertyContactButtonsComponent",

    components: {
        PropertyContactComponent: () => import("./PropertyContactComponent.vue")
    },

    props: [
        "property",
        "hasPhone",
        "hasEmail",
        "hasWebsite",
        "random",
        "ip",
        "userLevel",
        "illustration",
        "availability",
        "petsAllowed",
        "nhsDiscount",
        "showNhsDiscount"
    ],

    data() {
        return {
            ppContent: false,
            phoneContent: false,
            websiteContent: false,
            ownerPhone: null,
            ownerWebsite: null,
            instantErrors: null,
            instantAccess: this.property.p_instant_access
        };
    },

    methods: {
        instantContact() {
            this.instantErrors = null;
            this.response = null;
            axios
                .post("/instant-contact/", {
                    random: this.random,
                    type: this.contactType,
                    pid: this.property.p_aid,
                    ia: this.instantAccess,
                    ip: this.ip
                })
                .then(response => {
                    this.response = response.data;
                    if (this.response.phone !== undefined) {
                        this.responsePhone();
                    }
                    if (this.response.website !== undefined) {
                        this.responseWebsite();
                    }
                })
                .catch(e => {
                    if (e.response.data.message === "CSRF token mismatch.") {
                        this.instantErrors = {
                            csrf: [
                                "CSRF token mismatch - Please refresh the page"
                            ]
                        };
                    } else {
                        this.instantErrors = e.response.data.errors;
                    }
                });
        },

        showContact(type) {
            this.contactType = type;

            mutations.setContactOwnerType(type);

            if (this.instantAccess === 1) {
                if (this.contactType === "phone") {
                    this.instantContact();
                    return;
                }
                if (this.contactType === "website") {
                    this.instantContact();
                    return;
                }
            }

            this.toggleShow();
        },

        toggleShow() {
            mutations.toggleContactOwner();
        },

        responsePhone(phone = null) {
            if (!phone) {
                phone = this.response.phone;
            }
            this.ownerPhone = phone;
            this.phoneContent = true;
            this.ppContent = true;
        },
        responseWebsite(website = null) {
            if (!website) {
                website = this.response.website;
            }
            this.ownerWebsite = website;
            this.websiteContent = true;
            this.ppContent = true;
            window.open(this.ownerWebsite, "_blank");
        }
    },
    computed: {
        contactOwnerShow() {
            return store.state.contactOwnerShow;
        }
    }
};
</script>

<style scoped></style>
